import { z } from "zod";

export const blogFormSchema = z.object({
  title: z.string().min(1, "Title is required"),
  heading: z.string().min(1, "Heading is required"),
  description: z.string().min(1, "Description is required"),
  shortdescription: z.string().min(1, "Short description is required"),
  thumbnailImage: z.string(),
  images: z.custom<string[]>().optional(),
  blogsImagesFirst: z.string().optional().nullable(),
  blogsImagesSecond: z.string().optional().nullable(),
});

export type BlogFormData = z.infer<typeof blogFormSchema>;
